import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Módulos do Material
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';


import { AppRoutingModule } from './app-routing-module';
import { App } from './app';

// Interceptor
import { AuthInterceptor } from './interceptors/auth.interceptor';

// Serviços
import { AuthService } from './services/auth.service';
import { PessoaService } from './services/pessoa.service';
import { CobrancaService } from './services/cobranca.service';
import { ViaCepService } from './services/viacep.service';
import { ParcelamentoService } from './services/parcelamento.service';

// Componentes
import { LoginComponent } from './components/login/login.component';
import { PessoaFormComponent } from './components/pessoas/form/pessoa-form.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';


@NgModule({
  declarations: [
    App,
    LoginComponent,
    PessoaFormComponent,
    TopBarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    // Material Modules
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatDividerModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService,
    PessoaService,
    CobrancaService,
    ViaCepService,
    ParcelamentoService
  ],
  bootstrap: [App]
})
export class AppModule { }
